import { PageHero } from "@/components/site/PageHero";
import { Container, Overline } from "@/lib/ui";
import { RFPForm } from "@/components/site/RFPForm";
import { COMPANY } from "@/data/site";

export default function Contact() {
  return (
    <>
      <PageHero
        id="contact"
        overline="Contact"
        title="Let's discuss your portfolio."
        lead="Tell us about your assets and objectives. Our team will respond within one business day with a tailored operating and performance proposal."
      />
      <section className="py-24 md:py-32 bg-[#F7F7F5]">
        <Container>
          <div className="grid lg:grid-cols-12 gap-16">
            <div className="lg:col-span-4">
              <Overline>Get in Touch</Overline>
              <p className="mt-6 text-[#5C6660] leading-relaxed">
                For new management mandates, acquisitions, transitions and portfolio reviews. Complete the form and our
                team will respond within one business day.
              </p>
            </div>
            <div className="lg:col-span-8">
              <RFPForm />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
